import React from "react";

export default function Unauthorized() {
  return <h2>Zugriff verweigert: Du hast keine Berechtigung.</h2>;
}